import React, { ReactNode } from 'react'
import PropTypes from 'prop-types'

import * as Generic from './styles'
import * as TopBottom from './top-bottom'
import * as LeftRight from './left-right'

const StylesMap = {
  'top-bottom': TopBottom,
  'left-right': LeftRight,
}

const HeroCorner: React.FC<{
  heading?: string
  subheading?: string | null
  em?: string
  title?: string
  variant?: keyof typeof StylesMap | null
  action?: ReactNode
  background?: ReactNode
  noHeading?: boolean
  backgroundColor: string | undefined
  compact?: boolean
}> = ({
  heading,
  subheading,
  em,
  title,
  action,
  background,
  variant,
  noHeading,
  backgroundColor,
  slim,
}) => {
  const S = StylesMap[variant ?? 'top-bottom']

  return (
    <S.HeroCorner $slim={slim}>
      <Generic.BackgroundContainer $color={backgroundColor}>
        {background}
      </Generic.BackgroundContainer>
      <S.Wrapper>
        <S.CornerContainer>
          <Generic.Corner>
            {heading && (
              <Generic.CornerHeading as={noHeading ? 'span' : undefined}>
                {heading}
              </Generic.CornerHeading>
            )}
            {subheading && (
              <Generic.CornerSubHeading as={noHeading ? 'span' : undefined}>
                {subheading}
              </Generic.CornerSubHeading>
            )}
          </Generic.Corner>
        </S.CornerContainer>
        <S.InfoContainer>
          {em && <Generic.Em>{em}</Generic.Em>}
          {title && <Generic.Title>{title}</Generic.Title>}
          {action && <Generic.CTA>{action}</Generic.CTA>}
        </S.InfoContainer>
      </S.Wrapper>
    </S.HeroCorner>
  )
}

HeroCorner.propTypes = {
  background: PropTypes.node.isRequired,

  heading: PropTypes.string,
  subheading: PropTypes.string,

  title: PropTypes.string,
  em: PropTypes.string,

  action: PropTypes.node,
  variant: PropTypes.oneOf(['top-bottom', 'left-right']),
}

HeroCorner.defaultProps = {
  variant: 'top-bottom',
}

export default HeroCorner
